<template>
    <div style="padding: 1rem; display: flex; flex-direction: column; gap: 1rem;">
      <div class="shrumpExtende">
        <div class="shrumpCollapsebtn" @click="recolherTodos" v-if="openSections.length > 0">Recolher todos</div>
        <div class="extendeCollapsebtn" @click="expandirTodos" v-if="openSections.length <= 1 || openSections.length < lista.length">Expandir Todos</div>
      </div>
        <b-card v-for="(data,index) in lista" v-bind:key="index" no-body style="border: none; margin-bottom: 0rem; display: flex;">
            <b-card-header v-on:click="toggleSection(index)" header-tag="header" class="w-100 h-100 p-0 mb-0" role="tab" style="background-color: #E2E2E2;">
            <div  variant="info" class="head-mes d-flex align-items-center">
                <div class="title-left pl-3">
                <div class="title-colapse-mirror">{{data.nome}}</div>
                </div>
                <div class="componente">
                <i v-if="!openSections.includes(index)" class="fas fa-angle-down arrow-angel"></i>
                <i v-else class="fas fa-angle-up arrow-angel"></i>
                </div>
            </div>
            </b-card-header>
            <b-collapse
              :visible="openSections.includes(index)"
              id="id"
              role="tabpanel"
              ref="testeacor"
              style="margin-bottom: 0;"
              >
                <b-card-body style="padding: 0rem">
                    <Tables ref="tableGridsTemplateApr"
                        :columnsLeft= columTemplate
                        :showHeader="false"
                        :showSearch="false"
                        :showPrint="false"
                        :newHeaderStatus="false"
                        :showDownload="false"
                        :showFullscreen="false"
                        :showPaging="false"
                        :showTipFooter="false"
                        style="padding:0; font-family: 'Segoe UI'; text-align: start;"
                        :showAdd="true"
                        v-on:Popup="popUpAdd(data.categoria)"
                        v-on:Load="onLoad">
                        <template v-if="data.list && data.list.length > 0">
                          <tr v-for="(obj,index) in data.list" v-bind:key="index">
                            <TableColumn :IsText="true" style="width:90%; text-align: start !important;" :value="obj.descricao"></TableColumn>
                            <TableColumn :IsText="false"
                                        :IsActiveButton="true"
                                        :HasChange="true"
                                        :newEditGama="true"
                                        :HasDelete="true"
                                        v-on:Edit="popUpEdit(obj, data)"
                                        v-on:Delete="popUpDelete(obj, data.nome)"></TableColumn>
                          </tr>
                        </template>
                        <template v-else>
                            <tr>
                              <TableColumn :IsText="true" style="width:100%" value="Nenhum Resultado Encontrado"></TableColumn>
                            </tr>
                        </template>
                    </Tables>
                </b-card-body>
            </b-collapse>
        </b-card>
        <b-modal ref="edit-cadastro"
            size="md"
            centered
            id="add-edit-cadastro"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            >
            <template #modal-title>
                <!-- <div class="header-title">Editar Informações</div> -->
                <div class="header-title">{{titlePopup}}</div>
            </template>
            <collapseEditApr :form="form" @Load="fechaPopAtualizaGrid" ref="collapseEditApr"  @fechaPopAtualizaGrid="fechaPopAtualizaGrid"></collapseEditApr>
            <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="fechaPopAtualizaGrid">Cancelar</button>
                <button class="button-save" @click="salvaEditarCadastroBasico(form)">Salvar</button>
            </div>
        </b-modal>
        <b-modal ref="add-cadastro"
            size="md"
            centered
            id="add-edit-cadastro"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            >
            <template #modal-title>
                <!-- <div class="header-title">Editar Informações</div> -->
                <div class="header-title">{{titlePopup}}</div>
            </template>
            <collapseAddApr :formAdd="formAdd" @Load="fechaPopAddGrid"  @fechaPopAtualizaGrid="fechaPopAddGrid"></collapseAddApr>
            <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="fechaPopAddGrid">Cancelar</button>
                <button class="button-save" @click="salvaAdicaoCadastroBasico(formAdd)">Salvar</button>
            </div>
        </b-modal>
        <b-modal ref="delete-cadastro"
            size="md"
            centered
            id="delete-cadastro"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            >
            <template #modal-title>
                <!-- <div class="header-title">Editar Informações</div> -->
                <div class="header-title">Tem certeza de excluir esse cadastro?</div>
            </template>
            <div class="delete-model d-flex flex-column">
              <div>
                Template: <strong> {{ nomeLista }} </strong>
              </div>
              <div class="descricao-delete-model">
                <div>Descrição: </div>
                <div>
                  {{ deleteDescricao.descricao }}
                </div>
              </div>
            </div>
            <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="fechaPopDeleteGrid">Cancelar</button>
                <button class="button-delete" @click="DeleteCadastroBasico(deleteDescricao)">Excluir</button>
            </div>
        </b-modal>
        <b-modal ref="impossibilitado-exclusao"
            size="md"
            centered
            id="delete-cadastro"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            >
            <template #modal-title>
                <!-- <div class="header-title">Editar Informações</div> -->
                <div class="header-title">Não possível excluir o item de {{ nomeLista }}</div>
            </template>
            <div style="font-family: Segoe UI; font-size: 14px; width: 100%; text-align: center;">
              <div style="font-family: Segoe UI; font-size: 16px;">
                Remova o item dos templates que contém {{ deleteDescricao.descricao }}. Após isso, você poderá excluí-lo.
              </div>
            </div>
            <div style="font-family: Segoe UI; font-size: 14px; width: 100%; text-align: center; font-weight: bold; margin-top: 1rem;">TEMPLATES</div>
            <div style="display: flex; justify-content: center; width: 100%; margin-top: 1rem; margin-bottom: 0.5;" v-for="(data,index) in templatesLista" v-bind:key="index">
              <div style="background-color: rgb(203, 233, 207); color: rgb(19, 59, 26); border-radius: 10px; padding: 0.5rem; width: 8rem; text-align: center;">
                {{ data.codigoAtividade }}
              </div>
            </div>
            <div class="container-buttons-form pt-3">
                <button class="button-cancel" style="background-color: #dc3545; color: white;" @click="fechaPopTemplates">Fechar</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import collapseApr from './collapseApr'
export default collapseApr
</script>

<style scoped>
  .extendeCollapsebtn, .extendeCollapsebtn:hover {
    border-radius:5px;
    color:white;
    height:35px;
    width: 15%;
    border: 1px solid #CED4DA;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .extendeCollapsebtn{
    background-color:#008148;
  }
  .extendeCollapsebtn:hover{
    background-color:#03AC61;
  }
  .shrumpCollapsebtn, .shrumpCollapsebtn:hover{
    border-radius:5px;
    color:grey;
    height:35px;
    width: 15%;
    border: 1px solid #CED4DA;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .shrumpCollapsebtn{
    background-color:#F5F5F5;
  }
  .shrumpCollapsebtn:hover{
    background-color: #e4e5e6;;
  }
  .shrumpExtende{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
  }
  .descricao-delete-model{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .delete-model {
    gap: 1rem;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    font-size: 14px;
    font-family: 'Segoe UI';
  }
 .container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
  }

.button-cancel,.button-save,.button-delete{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .button-cancel{
    background-color: #dedede;
    color: #747474;
  }
  .button-save{
    background-color: #008148;
    color: white;
  }
  .button-delete{
    background-color: #dc3545;
    color: white;
  }
  .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
 .buttonaprova{
    height: 45px;
    display: flex;
    border-top: 1px solid #dee2e6;
  }
  .btn-rep{
    width: 10vw;
    background: red;
    margin-right: 5px;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
.btn-appr{
    width: 10vw;
    background: #008144;
    color: white;
    margin-left: 5px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
.title-left{
display: flex;
width: 100%;
height: 100%;
align-items: center;
}
.teste {
width:auto;
height: 300px;
overflow-x: scroll;
}

.tamanhofixo
{
text-align: center;
min-width: 300px;
}
.title-colapse-mirror{
    font-weight: bold;
    font-family: 'Segoe UI';
    font-size: 18px;
}
.table-cus{
width: 550%;
overflow-y: scroll;
}
thead{
width: 400px;
overflow: auto;
}
.componente{
font-size: 18px;
color: black;
padding-top: 9px;
padding-left: 15px;
}

.head-mes{
display: flex;
min-height: 40px;
padding: .1rem 0;
align-items: center;
justify-content: space-between;
cursor: pointer;
}
.arrow-angel{
font-size: 30px;
color: black;
padding-right: 20px;
padding-bottom: 10px;
}
.collapse-max{
overflow: auto;
height: 40vh;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/registerApr/components/collapseapr/collapseApr.vue